import RestrictMesh from "../resources/restrict-mesh";

class RestrictTransparency extends RestrictMesh {
    constructor() {
        super();
    }
}

export default RestrictTransparency;